const customers = () => {
    
    var carousel = $(".customers-slider")
    
    if(carousel.length > 0) {
        
        $(carousel).slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false
        })
        
    }
}

module.exports = {
    customers
};